var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3040_22811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.254 0 24-10.745 24-24C48 10.746 37.253.002 24 .002c-13.255 0-24 10.745-24 24 0 13.254 10.745 24 24 24z",
    fill: "#CB2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.937 32.139c-1.815-.14-2.577-1.04-4-1.904-.782 4.103-1.738 8.036-4.569 10.091-.874-6.201 1.283-10.86 2.285-15.804-1.708-2.875.205-8.661 3.808-7.235 4.433 1.753-3.839 10.69 1.714 11.806 5.798 1.165 8.164-10.06 4.569-13.71-5.195-5.272-15.12-.12-13.9 7.425.298 1.845 2.204 2.405.762 4.95-3.325-.736-4.317-3.358-4.19-6.853.207-5.722 5.142-9.729 10.093-10.283 6.261-.701 12.138 2.299 12.949 8.188.912 6.647-2.827 13.846-9.521 13.329z",
    fill: "#F1F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3040_22811"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.25e0203d83b263b3415bbde453c7d78c.svg";
export { ForwardRef as ReactComponent };